import { create } from 'zustand';

interface DominaBriefState {
  isExpanded: boolean;
  expand: () => void;
  collapse: () => void;
  toggle: () => void;
}

/**
 * Open state for Domina's morning brief — deliberately separate from the chat
 * widget store so the brief and the "Let's Chat" panel open/close independently
 * (X-ing one never affects the other).
 */
export const useDominaBriefStore = create<DominaBriefState>((set) => ({
  isExpanded: false,
  expand: () => set({ isExpanded: true }),
  collapse: () => set({ isExpanded: false }),
  toggle: () => set((s) => ({ isExpanded: !s.isExpanded })),
}));
